import React, { useEffect, useState } from "react";
import style from "css/device.module.css";
import Consult from "../neat/consult";
import Questions from "components/app/questions";

function ZoomPhone(props) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div className={style.device_title_wrap}>
        <div className={style.device_subtitle}>
          유연한 업무환경을 위한
          <br />
          <span>클라우드 기반 전화 시스템{"\n"} Zoom Phone</span>
        </div>
      </div>
      <div className={style.device_text}>
        유연한 업무 환경을 지원하는{"\n"} 클라우드 기반 VoIP 서비스
        <br />
      </div>

      <div className={style.device_img_list}>
        <img
          src={`${
            process.env.REACT_APP_CLIENT_URL
          }img/device/zoom/zoom_phone_1${isMobile ? "_m" : ""}.png`}
          alt="zoomphone"
        />
      </div>

      <div className={`${style.device_description_wrap} ${style.zoomphone}`}>
        <div className={style.device_description_title}>
          <span>Zoom Phone</span>
          <br />
          하드웨어를 활용한{"\n"}자율좌석 시스템
        </div>
        <div className={style.device_description_text}>
          <span>Zoom Phone 하드웨어</span>와{"\n"}{" "}
          <span>전자명패를 연동한</span> 자율좌석 시스템은
          <br /> 유동적인 업무 환경에서{"\n"} 사용자 편의와 효율성을
          극대화합니다.
        </div>
        <div className={style.device_description_img_wrap}>
          <div className={style.device_description_img_box}>
            <div className={style.device_description_img_box_header}>
              <div className={style.device_description_img_step_wrap}>
                STEP
                <span>01</span>
              </div>
              <div className={style.device_description_img_step_title}>
                QR 코드 스캔
              </div>
            </div>
            <img
              src={`${
                process.env.REACT_APP_CLIENT_URL
              }img/device/zoom/zoom_phone_step_1${isMobile ? "_m" : ""}.png`}
              alt="zoomphone"
            />
            <div className={style.device_description_img_step_text}>
              직원이 전자명패의 QR 코드를 스캔하여 체크인합니다.
            </div>
          </div>
          <div className={style.device_description_img_box}>
            <div className={style.device_description_img_box_header}>
              <div className={style.device_description_img_step_wrap}>
                STEP
                <span>02</span>
              </div>
              <div className={style.device_description_img_step_title}>
                기본 정보 연동
              </div>
            </div>
            <img
              src={`${
                process.env.REACT_APP_CLIENT_URL
              }img/device/zoom/zoom_phone_step_2${isMobile ? "_m" : ""}.png`}
              alt="zoomphone"
            />
            <div className={style.device_description_img_step_text}>
              이름·소속·부서 정보가 Zoom Phone에 자동으로 연동됩니다.
            </div>
          </div>
          <div className={style.device_description_img_box}>
            <div className={style.device_description_img_box_header}>
              <div className={style.device_description_img_step_wrap}>
                STEP
                <span>03</span>
              </div>
              <div className={style.device_description_img_step_title}>
                임시 전화기 사용
              </div>
            </div>
            <img
              src={`${
                process.env.REACT_APP_CLIENT_URL
              }img/device/zoom/zoom_phone_step_3${isMobile ? "_m" : ""}.png`}
              alt="zoomphone"
            />
            <div className={style.device_description_img_step_text}>
              체크인한 직원은 해당 Zoom Phone을 자신의 전화기로 임시 사용합니다.
            </div>
          </div>
          <div className={style.device_description_img_box}>
            <div className={style.device_description_img_box_header}>
              <div className={style.device_description_img_step_wrap}>
                STEP
                <span>04</span>
              </div>
              <div className={style.device_description_img_step_title}>
                일관된 통화환경 유지
              </div>
            </div>
            <img
              src={`${
                process.env.REACT_APP_CLIENT_URL
              }img/device/zoom/zoom_phone_step_4${isMobile ? "_m" : ""}.png`}
              alt="zoomphone"
            />
            <div className={style.device_description_img_step_text}>
              어디서든 동일한 통화 경험을 유지할 수 있습니다.
            </div>
          </div>
        </div>
      </div>

      <div className={`${style.device_features_wrap} ${style.zoomphone}`}>
        <div className={style.device_features_title}>
          리브테크놀로지의{"\n"} <span>자율좌석 시스템</span>을 통해
          <br />
          <span>스마트한 공간 활용</span>을 실현해보세요
        </div>
        <div className={style.device_features_list}>
          <div className={style.device_features_list_item}>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>1</div>
                <div className={style.device_features_item_label}>
                  실시간 예약 정보 표시
                </div>
              </div>
              <div className={style.device_features_text}>
                {isMobile
                  ? "QR 체크인을 통해 사용자 정보가 Zoom Phone에 즉시 연동되어, 직원이 자리에 앉자마자 전화기를 바로 사용할 수 있습니다. 이는 고정 전화 없이도 효율적인 통화 환경을 제공합니다."
                  : "QR 체크인을 통해 사용자 정보가 Zoom Phone에 즉시 연동되어, 직원이 자리에 앉자마자 전화기를 바로\n사용할 수 있습니다. 이는 고정 전화 없이도 효율적인\n통화 환경을 제공합니다."}
              </div>
            </div>
          </div>

          <div className={style.device_features_list_item}>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>2</div>
                <div className={style.device_features_item_label}>
                  개인화된 Phone 경험
                </div>
              </div>
              <div className={style.device_features_text}>
                {isMobile
                  ? "직원의 소속과 이름이 연동되어, 잠시 동안 개인 전화기 처럼 사용할 수 있습니다. 자신의 정보가 연동된 상태에서 전화기를 사용하므로 편리하고 안전한 통화가 가능합니다."
                  : "직원의 소속과 이름이 연동되어, 잠시 동안 개인 전화기\n처럼 사용할 수 있습니다. 자신의 정보가 연동된 상태\n에서 전화기를 사용하므로 편리하고 안전한 통화가\n가능합니다."}
              </div>
            </div>
          </div>

          <div className={style.device_features_list_item}>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>3</div>
                <div className={style.device_features_item_label}>
                  유연한 자율좌석 관리
                </div>
              </div>
              <div className={style.device_features_text}>
                {isMobile
                  ? "Zoom Phone 하드웨어와 전자명패가 연동된 시스템은 자율좌석제 환경에서 자리 이동 시 유연하게 대처할 수 있어, 사용자가 특정 자리에 구애받지 않고 일관된 업무 경험을 제공합니다"
                  : "Zoom Phone 하드웨어와 전자명패가 연동된 시스템은 자율좌석제 환경에서 자리 이동 시 유연하게 대처할 수 있어, 사용자가 특정 자리에 구애받지 않고 일관된 업무 경험을 제공합니다"}
              </div>
            </div>
          </div>

          <div className={style.device_features_list_item}>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>4</div>
                <div className={style.device_features_item_label}>
                  효율적인 공간 활용
                </div>
              </div>
              <div className={style.device_features_text}>
                {isMobile
                  ? "고정된 자리에 얽매이지 않고도 편리하게 전화기를 사용할 수 있어, 자율좌석제의 유동적인 공간 운영을 지원합니다. 이는 회의실, 공용라운지 등에서도 동일 하게 적용할 수 있어 다양한 공간에서 일관된 커뮤니케이션을 가능하게 합니다."
                  : "고정된 자리에 얽매이지 않고도 편리하게 전화기를\n사용할 수 있어, 자율좌석제의 유동적인 공간 운영을\n지원합니다. 이는 회의실, 공용라운지 등에서도 동일\n하게 적용할 수 있어 다양한 공간에서 일관된 커뮤니\n케이션을 가능하게 합니다."}
              </div>
            </div>
          </div>
        </div>

        <div className={style.device_feature_footer}>
          <div
            className={style.device_feature_footer_bg}
            style={{
              backgroundImage:
                "url('" +
                `${process.env.REACT_APP_CLIENT_URL}` +
                "img/smartspace/composefooterImg.png')",
            }}
          >
            <div className={style.device_feature_footer_icon_wrap}>
              <img
                alt=""
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/smartspace/bang.png"
                }
              />
            </div>
            <div className={style.device_feature_footer_text}>
              귀사의 환경에 맞는 Zoom Phone 하드웨어를 선택하고{"\n"}
              최적의 솔루션을 구축할 수 있도록 상담을 통해 정확히 진단해 보세요.
            </div>
          </div>
        </div>
      </div>

      {/* <div
        className={`${style.device_support_wrap} ${style.nameplate}`}
        style={{
          backgroundImage: `url('${
            process.env.REACT_APP_CLIENT_URL
          }img/device/nameplate/name_plate_bg${isMobile ? "_m" : ""}.png')`,
        }}
      >
        <span>
          Button 7.5 전자명패는{"\n"} QR 코드 기반의{"\n"} 스마트
          체크인/체크아웃 기능으로
          <br />
          자율좌석제 운영을 효율적으로 관리해,
          <br />더 나은 자리 관리와{"\n"} 최적의 공간 활용을 지원합니다.
        </span>
      </div> */}

      {props.type === "popup" ? (
        <div style={{ marginBottom: "70px" }}>
          <Consult />
        </div>
      ) : (
        <div className={style.device_consult_wrapper}>
          <Questions />
        </div>
      )}
    </>
  );
}

export default ZoomPhone;
